/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./sheep.vue?vue&type=template&id=a94cddaa&scoped=true"
import script from "./sheep.vue?vue&type=script&lang=js"
export * from "./sheep.vue?vue&type=script&lang=js"
import style0 from "./sheep.vue?vue&type=style&index=0&id=a94cddaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94cddaa",
  null
  
)

export default component.exports